/**
 * Centralized translations for Flow module
 * Contains all labels used across flow components (editors, data editors, etc.)
 */

export const FlowLabels = {
    it: {
        // Common labels
        close: 'Chiudi',
        save: 'Salva',
        fileSaved: 'File salvato',
        success: 'Successo',
        
        // Flow Editor
        aiPlan: 'AI Plan',
        design: 'Progettazione',
        saveThisFlow: 'Salva questo flusso',
        saveThisData: 'Salva questi dati',
        dataUpdated: 'Dati aggiornati',
        connecting: 'Connessione al motore AI',
        connected: 'Connesso',
        
        // Data Editor - Form fields
        name: 'Nome',
        description: 'Descrizione',
        isArrayMultipleRows: 'È un array (righe multiple)',
        isArrayDescription: 'Se selezioni questa opzione, i dati saranno rappresentati e modificati come una griglia di righe',
        nameUsedForFlowsAndMacros: 'Il nome utilizzato per flussi e macro sarà:',
        
        // Data Editor - Tabs
        main: 'Principale',
        schema: 'Schema',
        data: 'Dati',
        generalInformation: 'Informazioni generali del set di dati',
        schemaDefinition: 'Definizione dello schema: campi, tipi e commenti dei campi',
        dataContent: 'Contenuto dei dati',
        
        // Node Editors - Common
        enterTheName: 'Inserisci il nome',
        
        // Messages
        yourDataWasSuccessfullySaved: 'I tuoi dati sono stati salvati con successo',
        
        // Navigation
        home: 'Home'
    },
    
    en: {
        // Common labels
        close: 'Close',
        save: 'Save',
        fileSaved: 'File saved',
        success: 'Success',
        
        // Flow Editor
        aiPlan: 'AI Plan',
        design: 'Design',
        saveThisFlow: 'Save this flow',
        saveThisData: 'Save this data',
        dataUpdated: 'Data updated',
        connecting: 'Connecting to AI engine',
        connected: 'Connected',
        
        // Data Editor - Form fields
        name: 'Name',
        description: 'Description',
        isArrayMultipleRows: 'Is an array (multiple rows)',
        isArrayDescription: 'If you select this option, data will be represented and edited as a grid of rows',
        nameUsedForFlowsAndMacros: 'The name used for flows and macros will be:',
        
        // Data Editor - Tabs
        main: 'Main',
        schema: 'Schema',
        data: 'Data',
        generalInformation: 'General information of the data set',
        schemaDefinition: 'Schema definition: fields, types and field comments',
        dataContent: 'Data content',
        
        // Node Editors - Common
        enterTheName: 'Enter the name',
        
        // Messages
        yourDataWasSuccessfullySaved: 'Your data was successifully saved',
        
        // Navigation
        home: 'Home'
    }
}; 